import { StandardRates } from "us.collection.admin/constants/Actions";
import { IStandardRatesActions } from "us.collection.admin/interfaces";
import { IAPIAction } from "us.collection/interfaces";

const {
  INIT_GET_STANDARD_RATES,
  INIT_GET_STANDARD_RATES_SUCCESS,
  INIT_GET_STANDARD_RATES_FAILED,

  ADD_STANDARD_RATE,
  ADD_STANDARD_RATE_SUCCESS,
  ADD_STANDARD_RATE_FAILED,

  EDIT_STANDARD_RATE,
  EDIT_STANDARD_RATE_SUCCESS,
  EDIT_STANDARD_RATE_FAILED,

  HANDLE_STANDARD_RATES_DRAWER,
  DELETE_STANDARD_RATE,
} = StandardRates;

export const standardRates: Readonly<IAPIAction & IStandardRatesActions> = {
  init: {
    get: (data) => ({
      type: INIT_GET_STANDARD_RATES,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: INIT_GET_STANDARD_RATES_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: INIT_GET_STANDARD_RATES_FAILED,
      payload: {
        error,
        isLoading: false,
      },
    }),
    manageDrawer: (data) => ({
      type: HANDLE_STANDARD_RATES_DRAWER,
      payload: {
        data,
        isLoading: true,
      },
    }),
    delete: (data) => ({
      type: DELETE_STANDARD_RATE,
      payload: {
        data,
        isLoading: true,
      },
    }),
  },
  addStandardRate: {
    save: (data) => ({
      type: ADD_STANDARD_RATE,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: ADD_STANDARD_RATE_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: ADD_STANDARD_RATE_FAILED,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  editStandardRate: {
    save: (data) => ({
      type: EDIT_STANDARD_RATE,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: EDIT_STANDARD_RATE_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: EDIT_STANDARD_RATE_FAILED,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
};
